<ifc-offer-summary [application]="data.application"
                   [offerBundles]="data.offerBundles">
</ifc-offer-summary>
